import { useState } from "react";
import { hasPermissionForFuncInProject } from "src/utils/controllerHasPermissionsAdapter";
import { CustomSection } from "src/pages/OfferPage/CustomSections/CustomSection/CustomSection";
import { CustomSectionButton } from "src/pages/OfferPage/CustomSections/CustomSectionButton/CustomSectionButton";
import { ProjectQuoteUserProperties } from "src/model/api/project.model";
import { GetAllManufacturerDiscountForProjectResponse } from "src/model/api/manufacturer-discount.model";
import { ManufacturerRecommendationResponse } from "src/model/api/manufacturer-recommendation";
import { Product } from "src/model/product.model";

export const CustomSections = (
    {
        projectId,
        nonRoomTables,
        detailsEnabled,
        tablesEnabled,
        currency,
        currentRowInEditing,
        setCurrentRowInEditing,
        measurementSystem,
        quoteUserProperties,
        allManufacturerDiscountForProject,
        manufacturerRecommendationForProject,
        customItemsForRecommendation
    } : {
        projectId: number;
        nonRoomTables: any;
        detailsEnabled: boolean;
        tablesEnabled: boolean;
        currency: string;
        currentRowInEditing: any;
        setCurrentRowInEditing: any;
        measurementSystem: string;
        quoteUserProperties: ProjectQuoteUserProperties;
        allManufacturerDiscountForProject: GetAllManufacturerDiscountForProjectResponse;
        manufacturerRecommendationForProject: ManufacturerRecommendationResponse;
        customItemsForRecommendation: Product[];
    }
) => {


    const [customSectionButtonPressed, setCustomSectionButtonPressed] =
        useState();

    const tables =
        nonRoomTables &&
        nonRoomTables.filter((table: any) => table.entitytype === "sectiontable");

    return hasPermissionForFuncInProject(
        "quote_sect.add_custom_section",
        projectId
    ) ? (
        <div id="new-sections" className="break-before">
            {tables && tables.length
                ? tables.map((table: any, index: any) => (
                    <CustomSection
                        projectId={projectId}
                        index={index}
                        key={table.id}
                        table={table}
                        customSectionButtonPressed={customSectionButtonPressed}
                        setCustomSectionButtonPressed={setCustomSectionButtonPressed}
                        detailsEnabled={detailsEnabled}
                        tablesEnabled={tablesEnabled}
                        currency={currency}
                        currentRowInEditing={currentRowInEditing}
                        setCurrentRowInEditing={setCurrentRowInEditing}
                        measurementSystem={measurementSystem}
                        quoteUserProperties={quoteUserProperties}
                        allManufacturerDiscountForProject={allManufacturerDiscountForProject}
                        manufacturerRecommendationForProject={manufacturerRecommendationForProject}
                        customItemsForRecommendation={customItemsForRecommendation}
                    />
                ))
                : null}
            {customSectionButtonPressed &&
            currentRowInEditing &&
            currentRowInEditing.tableId &&
            currentRowInEditing.tableId === "new section" ? (
                <CustomSection
                    projectId={projectId}
                    table={null}
                    customSectionButtonPressed={customSectionButtonPressed}
                    setCustomSectionButtonPressed={setCustomSectionButtonPressed}
                    detailsEnabled={detailsEnabled}
                    tablesEnabled={tablesEnabled}
                    currency={currency}
                    currentRowInEditing={currentRowInEditing}
                    setCurrentRowInEditing={setCurrentRowInEditing}
                    measurementSystem={measurementSystem}
                    quoteUserProperties={quoteUserProperties}
                    allManufacturerDiscountForProject={allManufacturerDiscountForProject}
                    manufacturerRecommendationForProject={manufacturerRecommendationForProject}
                    customItemsForRecommendation={customItemsForRecommendation}
                />
            ) : null}
            <CustomSectionButton
                customSectionButtonPressed={customSectionButtonPressed}
                setCustomSectionButtonPressed={setCustomSectionButtonPressed}
                setCurrentRowInEditing={setCurrentRowInEditing}
            />
        </div>
    ) : null;
};
